@if (src()) {
<img [ngClass]="currentSize()" [src]="src()" class="rounded-full" />
} @else {
<div class="flex items-center justify-center bg-gray-100 border border-gray-200 rounded-full" [ngClass]="currentSize()">
  <app-icon [size]="size()" name="heroicons:user-16-solid" class="text-gray-400" />
</div>
}
